import type { FC } from 'react';
import type { ElementProps } from './Element';

import React from 'react';
import { customTwMerge } from '/react4xp/util/customTwMerge';
import { Element } from './Element';
import {
	GAP,
} from '../tailwind/gap';

type OmitDisplayProps = Omit<ElementProps,'display'>;

export const Flex: FC<OmitDisplayProps> = ({
	className,
	...otherProps
}) => <Element
	{...otherProps}
	className={customTwMerge('flex', className)}
/>;

export const Stack: FC<OmitDisplayProps & {
	rounded?: boolean;
}> = ({
	className,
	rounded = false, // Must come "first"
	borderStyle = rounded ? 'solid' : undefined, // Must come before border, borderColor and borderRadius.
	borderColor = (borderStyle && ['solid', 'dashed', 'dotted', 'double'].includes(borderStyle))
		? 'neutralSubtle'
		: undefined ,
	borderRadius = (borderStyle && ['solid', 'dashed', 'dotted', 'double'].includes(borderStyle)) ? 'md': undefined,
	borderWidth = (borderStyle && ['solid', 'dashed', 'dotted', 'double'].includes(borderStyle)) ? 1 : undefined,
	padding = rounded ? {
		block: 'lg',
		inline: 'md',
	} : undefined,
	gap = rounded ? 'xs' : undefined,
	tablet = rounded ? {} : undefined,
	...otherProps
}) => <Element
	{...otherProps}
	className={
		customTwMerge(
			`flex flex-col`,
			gap ? GAP[gap] : undefined,
			className,
		)
	}
	// TODO Move all these inside customTwMerge above
	borderColor={borderColor}
	borderRadius={borderRadius}
	borderStyle={borderStyle}
	borderWidth={borderWidth}
	padding={padding}
	tablet={rounded ? {
		padding: { all: 'xxl' },
		...tablet,
	} : undefined}
/>;

export const Row: FC<OmitDisplayProps> = ({
	className,
	...otherProps
}) => <Element
	{...otherProps}
	className={customTwMerge('flex flex-row', className)}
/>;

export const InlineRow: FC<OmitDisplayProps> = ({
	className,
	...otherProps
}) => <Element
	{...otherProps}
	className={customTwMerge('inline-flex flex-row', className)}
/>;
